import { render, staticRenderFns } from "./error403.vue?vue&type=template&id=6e1defe9&"
import script from "./error403.vue?vue&type=script&lang=ts&"
export * from "./error403.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports